/* unplugin-vue-components disabled */import { render } from "./CustomLog.vue?vue&type=template&id=78f7bffd&scoped=true&ts=true"
import script from "./CustomLog.vue?vue&type=script&lang=ts"
export * from "./CustomLog.vue?vue&type=script&lang=ts"

import "./CustomLog.vue?vue&type=style&index=0&id=78f7bffd&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f7bffd"]])

export default __exports__